import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton, GridToolbarQuickFilter
} from "@mui/x-data-grid";
import { Box, Grid, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";

function CustomToolbar() {
    return (
        <GridToolbarContainer title="Data" sx={{ justifyContent: 'flex-start' }}>
            <Typography variant="h6">Market Data</Typography>
            <GridToolbarColumnsButton />
            <GridToolbarFilterButton />
            <GridToolbarDensitySelector />
            <GridToolbarExport
                excelOptions={{ allColumns: true }}
                csvOptions={{
                    fileName: 'symbols-near-52-week-high',
                }}
            />
            <GridToolbarQuickFilter />
        </GridToolbarContainer>
    );
}
const NearTo52WHigh = ({ user }) => {
    const history = useHistory();
    const [rows, setRows] = useState([{ exchange: 'Loading...', symbol: '' }]);

    useEffect(() => {
        fetch(`/algo-trading/api/admin/symbols-near-52w-high`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                'Authorization': user.credential,
            }
        })
            .then(function (response) {
                response.text().then(r => {
                    if (response.ok) {
                        // console.log('SUCCESS', JSON.parse(r))
                        setRows(JSON.parse(r))
                    } else {
                        console.log('FAIL', r)
                        history.push("/")
                    }
                })
            }, function (error) {
                console.log('ERROR', error.message)
                history.push("/")
            })
    }, [user])

    const columns = [
        {
            field: 'symbol', headerName: 'Symbol (repeat count last 15 days)', width: "250", type: 'string',
            renderCell: (params) => (
                <>
                    <a href={"https://www.tradingview.com/chart/?symbol=NSE:" + params.value} target="_blank">
                        {params.value}
                    </a>
                    &nbsp;({params?.row?.count})
                </>
            ),
        },
        { field: 'ltp', headerName: 'LTP', width: "200", type: 'double' },
        { field: '_52WHigh', headerName: '52W High', width: "200", type: 'double' },
        {
            field: 'ltpHighPercentage', headerName: '% closer to High', width: "200", type: 'double',
            renderCell: (params) => (
                <>{params.value?.toFixed(2)}  %</>
            ),
        }
    ]
    return (
        <>
            <Grid item xs={12}>
                <Typography variant="h4" gutterBottom component="div">
                    Symbols Near 52 Week High
                </Typography>
            </Grid>
            <Grid item xs={12} md={5}>
                <Box>
                    {rows && <DataGrid
                        getRowId={(row) => row?.symbol}
                        rows={rows}
                        columns={columns}
                        initialState={{
                            sorting: {
                                sortModel: [{ field: 'ltpHighPercentage', sort: 'desc' }],
                            },
                            pagination: {
                                paginationModel: {
                                    pageSize: 25
                                }
                            }
                        }}
                        slots={{
                            toolbar: CustomToolbar
                        }}
                        sx={{ bgcolor: 'white' }}
                    />}
                </Box>
            </Grid>
        </>
    );
}

export default NearTo52WHigh;